// data-testid constants for the Vertex Elevators landing page.

export const NAV = {
  root: 'nav-root',
  logo: 'nav-logo',
  linkServices: 'nav-link-services',
  linkAbout: 'nav-link-about',
  linkProjects: 'nav-link-projects',
  linkContact: 'nav-link-contact',
  ctaEmergency: 'nav-cta-emergency',
  menuToggle: 'nav-menu-toggle',
};

export const HERO = {
  root: 'hero-section',
  ctaQuote: 'hero-cta-quote',
  ctaCall: 'hero-cta-call',
  image: 'hero-image',
};

export const STATS = {
  root: 'stats-strip',
  itemEstablished: 'stat-established',
  itemYears: 'stat-years',
  itemUnits: 'stat-units',
  itemResponse: 'stat-response',
};

export const SERVICES = {
  root: 'services-section',
  cardInstallation: 'service-card-installation',
  cardModernization: 'service-card-modernization',
  cardMaintenance: 'service-card-maintenance',
  cardAccessibility: 'service-card-accessibility',
};

export const ABOUT = {
  root: 'about-section',
};

export const PROJECTS = {
  root: 'projects-section',
  gallery: 'projects-gallery',
};

export const TESTIMONIALS = {
  root: 'testimonials-section',
};

export const CONTACT = {
  root: 'contact-section',
  form: 'contact-form',
  inputName: 'contact-input-name',
  inputEmail: 'contact-input-email',
  inputPhone: 'contact-input-phone',
  inputService: 'contact-input-service',
  inputBuilding: 'contact-input-building',
  inputMessage: 'contact-input-message',
  submit: 'contact-submit',
  success: 'contact-success',
  error: 'contact-error',
};

export const FOOTER = {
  root: 'footer-root',
};
